import { EmptyBoxImage } from '@approvalmax/ui';
import { Button, Flex, Popup, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';
import { Link } from 'react-router-dom';
import { getPath, Path } from 'urlBuilder';

import { messages } from './StarterGuideEmptyPopupContent.messages';
import { StarterGuideEmptyPopupContentProps } from './StarterGuideEmptyPopupContent.types';

export const StarterGuideEmptyPopupContent: FC<StarterGuideEmptyPopupContentProps> = memo((props) => {
    const { companyId, onClose } = props;

    const companyWorkflowsLink = getPath(Path.companyWorkflows, companyId);

    return (
        <>
            <Popup.Header />

            <Popup.Body spacing='20 32 32'>
                <Flex direction='column' alignItems='center' spacing='24'>
                    <EmptyBoxImage width={100} height={100} />

                    <Text font='headline' fontSize='small' fontWeight='medium' textAlign='center' color='midnight80'>
                        {messages.title}
                    </Text>

                    <Text font='body' fontSize='medium' textAlign='center' color='midnight100'>
                        {messages.description}
                    </Text>

                    <Button as={Link} to={companyWorkflowsLink} color='mint80' size='large' onClick={onClose}>
                        {messages.buttonText}
                    </Button>
                </Flex>
            </Popup.Body>
        </>
    );
});

StarterGuideEmptyPopupContent.displayName = 'StarterGuideEmptyPopupContent';
